import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchPDPA,
  createPDPA,
  updatePDPA,
  resetPDPA,
  deletePDPA
} from '../../modules/pdpa'

import {
  Tooltip,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import PDPAForm from './PDPAForm'

const PDPA = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { pdpa, isLoading } = useSelector(
    (state) => ({
      pdpa: state.pdpa.pdpa,
      isLoading: state.pdpa.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchPDPA())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => {}

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchPDPA())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updatePDPA(data))
    } else {
      await dispatch(createPDPA(data))
    }

    await dispatch(fetchPDPA())
    await setVisible(false)
    await setFormData({})
  }

  const onReset = async (appName) => {
    await dispatch(resetPDPA(appName))
  }

  const onDelete = async (id) => {
    await dispatch(deletePDPA(id))
    await dispatch(fetchPDPA())
  }
  const columns = [
    {
      title: 'App',
      dataIndex: 'app',
      key: 'app',
      width: 150
    },
    {
      title: 'Language',
      dataIndex: 'lang',
      key: 'lang',
      width: 150
    },
    {
      title: 'Detail',
      dataIndex: 'detail',
      key: 'detail',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 200
          }
        }
      },
      ...getColumnSearchProps('detail'),
      render: (detail, row) => (
        <Tooltip title={detail}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={detail.toString()}
            />
          </div>
        </Tooltip>
      )
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="PDPA"
      extra={
        <div>
          <Popconfirm
            title="Sure to reset?"
            onConfirm={() => onReset('GREEN2GET')}>
            <Button
              size="small"
              style={{ backgroundColor: '#6bc04a', color: '#ffffff' }}>
              RESET PDPA GREEN2GET
            </Button>
          </Popconfirm>
          <Popconfirm title="Sure to reset?" onConfirm={() => onReset('HERO')}>
            <Button
              size="small"
              style={{ backgroundColor: '#8282c8', color: '#ffffff' }}>
              RESET PDPA HERO
            </Button>
          </Popconfirm>
          <Popconfirm title="Sure to reset?" onConfirm={() => onReset('LOMA')}>
            <Button
              size="small"
              style={{ backgroundColor: '#344c7c', color: '#ffffff' }}>
              RESET PDPA หน้าร้านฮีโร่
            </Button>
          </Popconfirm>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create PDPA
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        rowKey={(record) => record.id}
        dataSource={pdpa}
        columns={columns}
      />
      <PDPAForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(withApollo)(PDPA)
